import React from 'react';
import { EmailBlock, SpacerBlockContent } from '../types';

// SpacerBlock component for email builder

interface SpacerBlockProps {
  block: EmailBlock;
  isSelected: boolean;
  onSelect: () => void;
  isDarkMode: boolean;
}

export const SpacerBlock: React.FC<SpacerBlockProps> = ({
  block,
  isSelected,
  onSelect,
  isDarkMode
}) => {
  const content = block.content as SpacerBlockContent;

  const style: React.CSSProperties = {
    height: `${content.height || 20}px`,
    width: '100%',
    ...block.styles
  };

  return (
    <div style={style} className="relative">
      {isSelected && (
        <div className="absolute inset-0 border-2 border-dashed border-accent-500 flex items-center justify-center">
          <span className="text-xs text-accent-500 bg-white dark:bg-gray-800 px-2">
            {content.height}px
          </span>
        </div>
      )}
    </div>
  );
};
